import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ArticleContent() {
    return (
        <MKBox component="section" py={6}>
            <Container maxWidth="lg">
                <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                    Întreținerea și spălarea pardoselilor
                </MKTypography>
                <MKTypography variant="body1" color="text" mb={2}>
                    În spații mici și medii folosim echipamente compacte, cu autonomie proprie, iar în zonele greu accesibile sau cu diferențe de nivel utilizăm sisteme manuale.
                </MKTypography>
                <MKTypography variant="body1" color="text" mb={4}>
                    Pentru suprafețe mari alegem utilajele după randamentul pe oră, autonomia necesară și frontul de lucru: mașini cu operator la bord, echipamente automatizate sau sisteme de roboți corelați pentru întreținere continuă.
                </MKTypography>

                <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                    Curățarea în profunzime
                </MKTypography>
                <MKTypography variant="body1" color="text" mb={2}>
                    Procesul începe cu analiza materialului, mediului și gradului de murdărie. Stabilim soluția tehnică, metoda de curățare și detergenții compatibili cu pardoseala.
                </MKTypography>
                <MKTypography variant="body1" color="text">
                    Etapa mecanizată curăță în profunzime prin degresare, decapare, detartrare sau deceruire. În multe cazuri, aceasta pregătește finisarea și protejarea prin ceruire, sigilare ori impermeabilizare.
                </MKTypography>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
